import {
  HTTP_DEPARTMENT_FETCHING,
  HTTP_DEPARTMENT_SUCCESS,
  HTTP_DEPARTMENT_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DEPARTMENT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_DEPARTMENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_DEPARTMENT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    default:
      return state;
  }
};
